/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { loadingTrue, loadingFalse } from "../../Reducer/loaderSlice";
import Handler from "../../Helpers/Handler";
import { toast } from "react-toastify";
import { reloadWindowToPath } from "../../Helpers/Utils";

const CreateRate = () => {

    const dispatch = useDispatch();
    const loading = useSelector(s => s.loading.loading);

    const [types, setTypes] = useState([]);
    const [customers, setCustomers] = useState([]);
    const [vehicles, setVehicles] = useState([]);

    // ⭐ Machan extra-va idhu rendu state dhaan add paniruken
    const [existingRates, setExistingRates] = useState([]);
    const [displayVehicles, setDisplayVehicles] = useState([]);

    const [form, setForm] = useState({
        customer_id: "",
        vehicle_id: "",
        lorry_type: "",
        normal_hrs: "",
        normal_hrs_ot: "",
        after_office_hrs: "",
        offz_hrs_ot: "",
        holiday: "",
        holiday_ot: "",
        gst_percent: 0
    });

    const loadInitialData = async () => {
        dispatch(loadingTrue());
        try {
            // 1. Load Active Customers
            const resCust = await Handler({ method: "get", url: "/customer/list.php?status=active&limit=1000" });
            if (resCust.success) {
                const activeCust = resCust.data.filter(c => c.status === "active" || c.is_active == 1);
                setCustomers(activeCust.map(c => ({ value: c.id, label: c.company_name })));
            }

            // 2. Load Active Vehicles
            const resVeh = await Handler({ method: "get", url: "/vehicle/list.php" });
            if (resVeh.success) {
                const activeVeh = resVeh.data.filter(v => v.status === "available" || v.is_active == 1);
                const formattedVehicles = activeVeh.map(v => ({
                    value: v.id,
                    label: `${v.vehicle_number} (${v.lorry_type})`,
                    lorry_type: v.lorry_type
                }));
                setVehicles(formattedVehicles);
                setDisplayVehicles(formattedVehicles); // Initial-ah ella vehicle-um kaatum

                const uniqueTypes = [...new Set(resVeh.data.map(t => t?.lorry_type))];
                setTypes(uniqueTypes.map(t => ({ value: t, label: t })));
            }

            // ⭐ 3. Load Existing Rates (Duplicate entry-a kandupidika)
            const resRates = await Handler({ method: "get", url: "/rate/list.php?limit=1000" });
            if (resRates.status || resRates.success) {
                setExistingRates(resRates.data);
            }

        } catch (err) {
            console.error(err);
        }
        dispatch(loadingFalse());
    };

    useEffect(() => { loadInitialData(); }, []);

    // ⭐ Machan indha logic dhaan mukkiyam:
    // Customer select panna odane, andha customer-ku munnadiye rate create panna vehicle-a remove panrom
    useEffect(() => {
        if (form.customer_id && existingRates.length > 0) {
            // 1. First, select panna customer-oda "label" (Company Name)-a edukurom
            const selectedCustomer = customers.find(c => String(c.value) === String(form.customer_id));
            const customerName = selectedCustomer ? selectedCustomer.label : "";

            // 2. Existing rates-la indha customer-ku ena ena vehicle numbers iruko adha edukurom
            const usedVehicleLabels = existingRates
                .filter(r => String(r.customer_name) === String(customerName))
                .map(r => String(r.vehicle_number));

            console.log("Customer Name:", customerName);
            console.log("Already used vehicles:", usedVehicleLabels);

            // 3. Vehicles list-la irundhu andha vehicle number iruka vehicles-a filter panrom
            const filtered = vehicles.filter(v => {
                // Vehicle label-la "TN 37 AB 1234 (Lorry)" nu irukum
                // Adhula irukira vehicle number-a mattum check panrom
                const vNumber = v.label.split(' (')[0];
                return !usedVehicleLabels.includes(vNumber);
            });

            setDisplayVehicles(filtered);
            setForm(prev => ({ ...prev, vehicle_id: "", lorry_type: "" }));
        } else {
            setDisplayVehicles(vehicles);
        }
    }, [form.customer_id, existingRates, vehicles, customers]);

    const handleChange = e => {
        const { name, value } = e.target;
        setForm({ ...form, [name]: value });
    };

    const handleSubmit = async e => {
        e.preventDefault();
        dispatch(loadingTrue());

        const res = await Handler({
            method: "post",
            url: "/rate/create.php",
            data: form
        });

        if (res.status || res.success) {
            toast.success(res.message || "Pricing created successfully");
            setTimeout(() => reloadWindowToPath("/rates"), 1000);
        } else toast.error(res.message || "Error creating rate");

        dispatch(loadingFalse());
    };

    return (
        <div className="page-card">

            <div className="page-header">
                <h4>Create Rate</h4>
            </div>

            <form onSubmit={handleSubmit} className="form-grid">

                {/* Customer Selection */}
                <div className="form-group">
                    <label>Select Customer</label>
                    <Select
                        options={customers}
                        placeholder="Choose active customer"
                        onChange={(opt) => setForm({ ...form, customer_id: opt.value })}
                        required
                    />
                </div>

                {/* Vehicle Selection */}
                <div className="form-group">
                    <label>Select Vehicle</label>
                    <Select
                        options={displayVehicles} // 👈 filtered list-a inga kuduthuten
                        value={displayVehicles.find(v => v.value === form.vehicle_id) || null}
                        placeholder={form.customer_id ? "Choose active vehicle" : "Select customer first"}
                        onChange={(opt) => setForm({
                            ...form,
                            vehicle_id: opt ? opt.value : "",
                            lorry_type: opt ? opt.lorry_type : ""
                        })}
                        required
                    />
                </div>

                {/* GST */}
                <div className="form-group">
                    <label>GST %</label>
                    <input name="gst_percent" placeholder="Enter GST %" value={form.gst_percent} className="form-control" onChange={handleChange} />
                </div>

                {/* Normal Hrs Rate */}
                <div className="form-group">
                    <label>Normal Hrs Rate</label>
                    <input
                        name="normal_hrs"
                        type="number"
                        step="0.01"
                        className="form-control"
                        placeholder="Enter base rate"
                        value={form.normal_hrs}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="form-group">
                    <label>Normal Hrs OT Rate</label>
                    <input name="normal_hrs_ot" placeholder="OT Rate" value={form.normal_hrs_ot} className="form-control" onChange={handleChange} />
                </div>

                <div className="form-group">
                    <label>After Office Hrs Rate</label>
                    <input name="after_office_hrs" placeholder="Late Hrs Rate" value={form.after_office_hrs} className="form-control" onChange={handleChange} />
                </div>

                <div className="form-group">
                    <label>Office Hrs OT Rate</label>
                    <input name="offz_hrs_ot" placeholder="Office OT Rate" value={form.offz_hrs_ot} className="form-control" onChange={handleChange} />
                </div>

                <div className="form-group">
                    <label>Holiday Rate</label>
                    <input name="holiday" placeholder="Holiday Rate" value={form.holiday} className="form-control" onChange={handleChange} />
                </div>

                <div className="form-group">
                    <label>Holiday OT Rate</label>
                    <input name="holiday_ot" placeholder="Holiday OT Rate" value={form.holiday_ot} className="form-control" onChange={handleChange} />
                </div>

                <div className="form-group full">
                    <button className="btn add-btn-add" disabled={loading}>
                        {loading
                            ? (<><span className="spinner-border spinner-border-sm me-2"></span>Saving...</>)
                            : "Create Rate"}
                    </button>
                </div>

            </form>
        </div>
    );
};

export default CreateRate;